export default {
  namespaced: true,
  state: {
    userInfo: {},
  },
  getters: {},
  mutations: {
    initUserInfo: (state) => {
      state.userInfo = {};
    },
    setUserInfo: (state, data) => {
      state.userInfo = data;
    },
  },
  actions: {
    async login({ commit, state }, data) {
      try {
        let res = await axios.post(`/api/login`, data);
        Vue.prototype.$cookies.set("auth", {
          token: res.data.token.access_token,
          expires: res.data.token.expires,
        });
      } catch (e) {
        throw e;
      }
    },
    async backstageLogin({ commit, state }, data) {
      try {
        let res = await axios.post(`/api/backstage_login`, data);
        Vue.prototype.$cookies.set("auth", {
          token: res.data.token.access_token,
          expires: res.data.token.expires,
        });
      } catch (e) {
        throw e;
      }
    },
    logout() {
      const keys = Vue.prototype.$cookies.keys();
      keys.forEach((key) => Vue.prototype.$cookies.remove(key));
    },
    async sendEmailToResetPassword({ commit, state }, data) {
      try {
        let res = await axios.post(`/api/send_email_reset_password`, data);
      } catch (e) {
        throw e;
      }
    },
    async resetPasswordToServer({ commit, state }, data) {
      try {
        let res = await axios.post(`/api/reset_password`, data);
      } catch (e) {
        throw e;
      }
    },
    async getUserDataByToken({ commit, state }) {
      try {
        let res = await axios.get(`/api/user`);
        commit("setUserInfo", res.data.user_info);
      } catch (e) {
        throw e;
      }
    },
  },
};
